module.exports = __webpack_public_path__ + "img/5 Quelle solution _.40e88515.png";